import platDataMap from "@/data/system/platDataMap.js";
import controlConfig from "@/components/controls/index.js";

// 集合在form组件里的，和项目有关的控件配置表
window.controlConfig = controlConfig;

// 请求接口地址的配置
let params = require("../config/index.js");

let developmentSocketUrl = params.dev.proxyTable["/api"].target;

// 系统配置
window.platDataMap = platDataMap;

window.config = {
    env: process.env.NODE_ENV,
    apiUrl: "/api",
    socketUrl: process.env.NODE_ENV === "development" ? developmentSocketUrl : (process.env.NODE_ENV === "newstaging" ? "http://120.27.9.159:10202" : (process.env.NODE_ENV === "production" ? "http://39.97.211.251:3008" : window.location.origin))
};



// WEBPACK FOOTER //
// ./src/window.js